import { render, staticRenderFns } from "./EditPartnerSubscription.vue?vue&type=template&id=a163226a"
import script from "./EditPartnerSubscription.vue?vue&type=script&lang=js"
export * from "./EditPartnerSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports